module.exports = __webpack_public_path__ + "img/cb375c2.jpg";